import { createSelector } from 'reselect';

export const selectAuthState = (state) => state.auth;

export const selectUserDataState = createSelector(
  selectAuthState,
  ({ userData }) => userData
);
